import React from 'react';

const BenchmarkIcon = () => {
  return (
    <svg viewBox="0 0 173.26 126.24" preserveAspectRatio="xMidYMin">
      <rect x="27.52" y="30.29" width="118.21" height="10.85" rx="3.08" fill="#01ab98"/>
      <rect x="27.52" y="49.33" width="108.23" height="10.85" rx="3" fill="#01ab98"/>
      <rect x="27.52" y="68.36" width="96.21" height="10.85" rx="2.99" fill="#60d8c6"/>
      <rect x="27.52" y="87.39" width="82.68" height="10.85" rx="3" fill="#f47046"/>
      <path fill="none" stroke="#a9aeb7" strokeLinecap="round" strokeMiterlimit="10" strokeDasharray="3,5" d="M127.79 10.72v104.87"/>
      <path fill="none" stroke="#a9aeb7" strokeLinecap="round" strokeMiterlimit="10" d="M22.52 20.51v87.51"/>
      <path fill="none" stroke="#a9aeb7" strokeLinecap="round" strokeMiterlimit="10" strokeDasharray="3,5" d="M113.86 10.68v104.88"/>
    </svg>
  );
}

export default BenchmarkIcon;